module.exports = __webpack_public_path__ + "static/media/BeautyandtheBesharamBookCover.5f725c18.jpg";